(function () {
  /**
   * @ngdoc module
   * @name binky.core.cart
   * @description Module which contains cart related models and services
   */
  angular.module('binky.core.cart', ['binky.core.lodash']);
})();
